import React from 'react'

function LocateTrack({ colorCode, classSidebar, onClickLocate }) {
    return (
        <svg className={`MuiSvgIcon-root ${classSidebar}`} viewBox="0 0 23 27" style={{ fill: 'none' }} onClick={onClickLocate}>
            <path d="M22 11.1765C22 19.0511 11.8755 25.8008 11.8755 25.8008C11.8755 25.8008 1.75098 19.0511 1.75098 11.1765C1.75098 8.49133 2.81766 5.91612 4.71638 4.0174C6.61509 2.11869 9.1903 1.052 11.8755 1.052C14.5607 1.052 17.1359 2.11869 19.0346 4.0174C20.9333 5.91612 22 8.49133 22 11.1765Z" stroke={colorCode} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.8758 14.5514C13.7397 14.5514 15.2507 13.0404 15.2507 11.1765C15.2507 9.31266 13.7397 7.8017 11.8758 7.8017C10.0119 7.8017 8.50098 9.31266 8.50098 11.1765C8.50098 13.0404 10.0119 14.5514 11.8758 14.5514Z" stroke={colorCode} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default LocateTrack
